
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexiNtA_znKj_zn_45wsEgsmLpyYSVS7XVZ24_KIDRjqK_10Meta } from "/app/src/pages/index.vue?macro=true";
import { default as _91_46_46_46slug_93z2ulRrSyHEiAZI_45QPu61kAXVIQtxyzT9Tt2nhVlsYzsMeta } from "/app/src/pages/[...slug].vue?macro=true";
import { default as indexdgQx7g7QT23PEjYuD5reWSWl2ul4QxvUu8_cWe8DR7EMeta } from "/app/src/pages/gift-cards/index.vue?macro=true";
import { default as indexwhL7ta1uUDCBCmiDxQ82jcLiEvnKR17MHJtg9pp637wMeta } from "/app/src/pages/mad-bunday/index.vue?macro=true";
import { default as submitpnJu8NZ8cRGW1WibJHk085_458YzhZEeZdGJ_6MbiaIsoMeta } from "/app/src/pages/mad-bunday/submit.vue?macro=true";
import { default as index8OC2L2FcEmfgzMKSbx4zDmrlrMX_45Q3MD0C9Js3oQty4Meta } from "/app/src/pages/restaurants/index.vue?macro=true";
import { default as success_45qhRhUh0aQvzdg7aIvPBY1s5rPCZdPY3ink1iECOxBEMeta } from "/app/src/pages/gift-cards/success.vue?macro=true";
import { default as purchasenqsexBwXYOcPhuwrhG_Bv_45U4HDTMmEJxjxmd9hbynQQMeta } from "/app/src/pages/gift-cards/purchase.vue?macro=true";
import { default as _91_46_46_46slug_93zUB2IyzdHk1sRecFCcW4Tlwtqv5kGA2SrPPUZ2MShuMMeta } from "/app/src/pages/gift-cards/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93CZnw3axu6xmHPfNkzE7xDTzVwfv0a3oq3QmwQrntHjUMeta } from "/app/src/pages/mad-bunday/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_9399T3C4zBtOYCrHMMeizwEMhtDJAf4fbC6nwaCmQFl3AMeta } from "/app/src/pages/restaurants/[...slug].vue?macro=true";
import { default as confirmation_45degcuW54Bgd1TQ8sgRIPa3fG7or2yXmEA7Qy3B0b3IMeta } from "/app/src/pages/mad-bunday/confirmation.vue?macro=true";
import { default as indexYNLe4HL20QivCODvquV4_77GqHu36W_4WosyTiVHItQMeta } from "/app/src/pages/local-matters-coles/index.vue?macro=true";
import { default as _91_46_46_46slug_93jGMNk6zd1J71IPX8C1hTtAT8Hd5YwW2R0zcEBRr0FXEMeta } from "/app/src/pages/local-matters-coles/[...slug].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/src/pages/index.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/app/src/pages/[...slug].vue")
  },
  {
    name: "gift-cards",
    path: "/gift-cards",
    component: () => import("/app/src/pages/gift-cards/index.vue")
  },
  {
    name: "mad-bunday",
    path: "/mad-bunday",
    component: () => import("/app/src/pages/mad-bunday/index.vue")
  },
  {
    name: "mad-bunday-submit",
    path: "/mad-bunday/submit",
    meta: submitpnJu8NZ8cRGW1WibJHk085_458YzhZEeZdGJ_6MbiaIsoMeta || {},
    component: () => import("/app/src/pages/mad-bunday/submit.vue")
  },
  {
    name: "restaurants",
    path: "/restaurants",
    component: () => import("/app/src/pages/restaurants/index.vue")
  },
  {
    name: "gift-cards-success",
    path: "/gift-cards/success",
    component: () => import("/app/src/pages/gift-cards/success.vue")
  },
  {
    name: "gift-cards-purchase",
    path: "/gift-cards/purchase",
    component: () => import("/app/src/pages/gift-cards/purchase.vue")
  },
  {
    name: "gift-cards-slug",
    path: "/gift-cards/:slug(.*)*",
    component: () => import("/app/src/pages/gift-cards/[...slug].vue")
  },
  {
    name: "mad-bunday-slug",
    path: "/mad-bunday/:slug(.*)*",
    component: () => import("/app/src/pages/mad-bunday/[...slug].vue")
  },
  {
    name: "restaurants-slug",
    path: "/restaurants/:slug(.*)*",
    component: () => import("/app/src/pages/restaurants/[...slug].vue")
  },
  {
    name: "mad-bunday-confirmation",
    path: "/mad-bunday/confirmation",
    meta: confirmation_45degcuW54Bgd1TQ8sgRIPa3fG7or2yXmEA7Qy3B0b3IMeta || {},
    component: () => import("/app/src/pages/mad-bunday/confirmation.vue")
  },
  {
    name: "local-matters-coles",
    path: "/local-matters-coles",
    meta: indexYNLe4HL20QivCODvquV4_77GqHu36W_4WosyTiVHItQMeta || {},
    component: () => import("/app/src/pages/local-matters-coles/index.vue")
  },
  {
    name: "local-matters-coles-slug",
    path: "/local-matters-coles/:slug(.*)*",
    component: () => import("/app/src/pages/local-matters-coles/[...slug].vue")
  }
]